import React, { useState, useCallback, useEffect } from 'react';
import classNames from 'classnames';
import Footer from './components/Footer';
import ReferAFriend from './components/ReferAFriend';
import Animation from 'components/Animation';
import { useLocation } from 'react-router-dom';

import './FooterWrapper.styles.scss';

type FooterWrapperProps = {
  className?: string;
};

const FooterWrapper: React.FC<FooterWrapperProps> = (props) => {
  const { className } = props;

  const [showRefer, setShowRefer] = useState(false);

  const { pathname } = useLocation();

  const classes = classNames('footer-wrapper', className);

  useEffect(() => {
    setShowRefer(false);
  }, [pathname]);

  const onReferFriend = useCallback(() => {
    setShowRefer((old) => !old);
  }, []);

  return (
    <div className={classes}>
      <Animation
        duration={300}
        open={showRefer}
        appearAnimation="appear"
        disappearAnimation="disappear"
        timingFunction="ease-in-out"
      >
        <div className="footer-wrapper__refer">
          <ReferAFriend onClose={onReferFriend} />
        </div>
      </Animation>

      <Footer
        reffering={!showRefer}
        onRefer={onReferFriend}
        className="dash__footer"
      />
    </div>
  );
};

export default FooterWrapper;
